module.exports = __webpack_public_path__ + "static/img/home_40.343fc406.png";